export enum NoteType {
    Installation = 'Installation',
    Care = 'Care',
    Transportation = 'Transportation',
    Conservation = 'Conservation',
    Exhibition = 'Exhibition',
    General = 'General'
}

export interface NoteTag {
    id: number;
    name: string;
    color: string;
}

export interface Note {
    id: number;
    artworkId: number;
    title: string;
    content: string;
    noteTypeId: number;
    createdAt: string;
    updatedAt: string;
    createdBy: string;
    tags: string[];
    priority: number;
}

export interface CreateNoteRequest {
    artworkId: number;
    title: string;
    content: string;
    noteTypeId: number;
    tags: string[];
    priority: number;
}

export interface UpdateNoteRequest extends CreateNoteRequest {
    id: number;
}

export interface NotesFilterStruct {
    search: string;
    noteTypeId: number;
    tags: string[];
    priority: string;
}

export type NotesFilterWithoutSearch = Omit<NotesFilterStruct, 'search'>;

export interface PriorityOption {
    value: string;
    label: string;
    color: string;
}

export interface SearchNotesRequest {
    searchTerm?: string;
    noteTypeId?: number;
    tags?: string[];
    priority?: number;
    dateFrom?: string;
    dateTo?: string;
    sortBy?: string;
    sortDescending?: boolean;
}

export type NoteTypeDto = {
    noteTypeId: number;
    name: string;
    code: string;
    sortOrder: number;
    isSystem: boolean;
};

export type CreateNoteTypeDto = {
    name: string;
    sortOrder?: number;
};

export type UpdateNoteTypeDto = {
    name: string;
    sortOrder?: number;
};

export function getNoteTypeIdByCode(noteTypes: NoteTypeDto[], code: string): number {
    const key = (code ?? "").trim().toUpperCase();
    if (!key) throw new Error("NoteType code is required.");

    const match = noteTypes.find(nt => (nt.code ?? "").toUpperCase() === key);
    if (!match) throw new Error(`NoteType with code '${code}' not found.`);

    return match.noteTypeId;
}